import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// --- Types ---
interface AnonQrState {
  isQrCodeStylesUpdating: boolean;
}

// --- Initial State ---
const initialState: AnonQrState = {
  isQrCodeStylesUpdating: false,
};

// --- Slice ---
export const anonQrSlice = createSlice({
  name: 'anonQrSlice',
  initialState,
  reducers: {
    setIsQrCodeStylesUpdating: (state, action: PayloadAction<boolean>) => {
      state.isQrCodeStylesUpdating = action.payload;
    },
  },
});

export const { setIsQrCodeStylesUpdating } = anonQrSlice.actions;

export default anonQrSlice.reducer;
